import React, { useEffect, useState } from "react";
import { api } from "../../utils/Api";
import "../../assets/css/style.css";
import { Link } from "react-router-dom";

export default function UserSkills(props: any) {
  const [user_skills, setUserSkills] = useState([]);

  useEffect(() => {
    console.log("UserSkills on mount :", props);

    // if (props.from == "create_account") {
    //   get_init();
    // }
    get_init();
  }, []);

  async function get_init() {
    let response: any = await api("/users/edit_skills_init");
    console.log("edit_skills_init :", response);
    if (response.response.hasOwnProperty("skill_categories")) {
      setUserSkills(response.response.skill_categories);
    }
  }

  async function update_skills() {
    let pass_data = {
      post: {
        skills: user_skills,
      },
    };
    console.log("passdata :", pass_data);
    let response: any = await api("/users/update_skills", pass_data);
    console.log("response : ", response);
    if (response.status_code == 201) {
      // props.on_next(response.response.user_skills);
    
    }
  
  }

  function submitSkills() {
    const frmSkills = user_skills;
    console.log(frmSkills);
  }

  return (
    <div>
      {props.from != "create_account" ? (
        <div className="container pt-3">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="card p-3">
                <h3>Skills</h3>
                <div className="d-flex mt-3">
                  {user_skills.map((dataSkill: any, index: any) => (
                    <div key={index}>
                      {/* Inside map function */}
                      <div className="skills-block">
                        <input
                          name="enable"
                          className="form-check-input d-none"
                          type="checkbox"
                          id={"skillCat" + index}
                          checked={dataSkill.checked}
                          onChange={(event) => {
                            setUserSkills((preVlaue: any) => {
                              preVlaue[index].checked =
                                !preVlaue[index].checked;
                              if (!preVlaue[index].checked) {
                                preVlaue[index].skills.map(
                                  (ele: any, ele_index: any) => {
                                    ele.checked = false;
                                  }
                                );
                              }
                              return [...preVlaue];
                            });
                          }}
                        />
                        <i className="fas fa-check-circle text-success skills-ckeck"></i>
                        <label
                          className="d-flex flex-column form-check-label"
                          for={"skillCat" + index}
                        >
                          <div className="text-center">
                            <img
                              src={dataSkill.icon_url}
                              alt="display image"
                              width="30"
                            />
                          </div>
                          <div className="form-check-label mt-1 fs-10">
                            {dataSkill.name}
                          </div>
                        </label>
                      </div>
                    </div>
                  ))}{" "}
                </div>
                {/* <hr /> */}
                <div className="mt-3 px-3">
                  {user_skills.map((dataSkillitem, index) => (
                    <div key={index}>
                      {dataSkillitem.checked && (
                        <div>
                          <div className="mt-3 mb-3">{dataSkillitem.name}</div>

                          {dataSkillitem.skills.map((dataSkill_G, yandex) => (
                            <div key={yandex} className="form-check mb-3">
                              <input
                                name="enable"
                                type="checkbox"
                                className="form-check-input"
                                id={"skillItems" + index + "_" + yandex}
                                checked={dataSkill_G.checked}
                                onChange={(event) => {
                                  setUserSkills((preVlaue) => {
                                    preVlaue[index].skills[yandex].checked =
                                      !preVlaue[index].skills[yandex].checked;
                                    return [...preVlaue];
                                  });
                                }}
                              />
                              <label
                                className="form-check-label"
                                for={"skillItems" + index + "_" + yandex}
                              >
                                {dataSkill_G.name}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                  {/* <hr /> */}
                </div>
                {props.from == "create_account" ? (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      className="btn btn-outline-success fw-bold border-0"
                      onClick={() => {
                        update_skills();
                      }}
                    >
                      Next <i className="fas fa-angle-right"></i>
                    </button>
                  </div>
                ) : (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                       <Link className="btn btn-secondary px-3" to="/profile">Back</Link>
                    <Link  to="/profile">
                    <button
                      type="button"
                      className="btn btn-primary px-3 ms-2"
                      onClick={() => {
                        update_skills();

                        console.log("hi")
                        
                      }}
                    >    
                      Save
        
                    </button>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="pt-3">
        <div className="card p-3">
          <h3>Skills</h3>
          <div className="d-flex mt-3">
            {user_skills.map((dataSkill: any, index: any) => (
              <div key={index}>
                {/* Inside map function */}
                <div className="skills-block">
                  <input
                    name="enable"
                    className="form-check-input d-none"
                    type="checkbox"
                    id={"skillCat" + index}
                    checked={dataSkill.checked}
                    onChange={(event) => {
                      setUserSkills((preVlaue: any) => {
                        preVlaue[index].checked = !preVlaue[index].checked;
                        if (!preVlaue[index].checked) {
                          preVlaue[index].skills.map(
                            (ele: any, ele_index: any) => {
                              ele.checked = false;
                            }
                          );
                        }
                        return [...preVlaue];
                      });
                    }}
                  />
                  <i className="fas fa-check-circle text-success skills-ckeck"></i>
                  <label
                    className="d-flex flex-column form-check-label"
                    for={"skillCat" + index}
                  >
                    <div className="text-center">
                      <img
                        src={dataSkill.icon_url}
                        alt="display image"
                        width="30"
                      />
                    </div>
                    <div className="form-check-label mt-1 fs-10">
                      {dataSkill.name}
                    </div>
                  </label>
                </div>
              </div>
            ))}{" "}
          </div>
          {/* <hr /> */}
          <div className="mt-3 px-3">
            {user_skills.map((dataSkillitem, index) => (
              <div key={index}>
                {dataSkillitem.checked && (
                  <div>
                    <div className="mt-3 mb-3">
                      {/* {dataSkillitem.id} {dataSkillitem.name} */}
                      {dataSkillitem.name}
                    </div>

                    {dataSkillitem.skills.map((dataSkill_G, yandex) => (
                      <div key={yandex} className="form-check mb-3">
                        <input
                          className="form-check-input"
                          name="enable"
                          type="checkbox"
                          id={"skillItems" + index + "_" + yandex}
                          checked={dataSkill_G.checked}
                          onChange={(event) => {
                            setUserSkills((preVlaue) => {
                              preVlaue[index].skills[yandex].checked =
                                !preVlaue[index].skills[yandex].checked;
                              return [...preVlaue];
                            });
                          }}
                        />
                        <label
                          className="form-check-label"
                          for={"skillItems" + index + "_" + yandex}
                        >
                          {dataSkill_G.name}
                        </label>
                        {/* {dataSkill_G.id} {dataSkill_G.name} */}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {/* <hr /> */}
          </div>
          {props.from == "create_account" ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                className="btn btn-primary px-3"
                onClick={() => {
                  update_skills();
                }}
              >
                Next <i className="fas fa-angle-right "></i>
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                className="btn btn-outline-success  border-0 fw-bold"
                onClick={() => {
                  update_skills();
                }}
              >
                Next <i className="fas fa-angle-right"></i>
              </button>
            </div>
          )}
        </div>
        </div>
      )}
    </div>
  );
}
